import React, { useEffect, useMemo, useState } from "react";

import {

  buildRequestPlaceholder,

  buildRequestSearchTokens,

  buildSignSearchTokens,

  getEntityDocumentId,
  getSignEntryDisplayValue,

  signEntryMatchesToken,

  useAppStore,

} from "../store/useAppStore";

import UniversalModal from "./items/UniversalModal";



const formatSignsPreview = (signs, tokens) => {

  if (!Array.isArray(signs) || !signs.length) return "—";

  const tokenList = Array.isArray(tokens) ? tokens : [tokens];



  return signs.map((entry, index) => {

    const text = getSignEntryDisplayValue(entry);

    const isMatch = tokenList.some((token) => signEntryMatchesToken(entry, token));

    return (

      <React.Fragment key={`${text}-${index}`}>

        {index > 0 ? ", " : null}

        <span className={isMatch ? "request-usage-placeholder" : ""}>{text}</span>

      </React.Fragment>

    );

  });

};



const SignTranslationUsageModal = ({ isOpen, mode = "request", entity, onClose }) => {

  const findSignRequestPlaceholderUsage = useAppStore((state) => state.findSignRequestPlaceholderUsage);

  const findSignUsage = useAppStore((state) => state.findSignUsage);

  const signRequestUsageLoading = useAppStore((state) => state.signRequestUsageLoading);

  const signRequestUsageError = useAppStore((state) => state.signRequestUsageError);

  const signUsageLoading = useAppStore((state) => state.signUsageLoading);

  const signUsageError = useAppStore((state) => state.signUsageError);



  const [usageItems, setUsageItems] = useState([]);

  const [totalTranslations, setTotalTranslations] = useState(0);

  const [searchTokens, setSearchTokens] = useState([]);



  const isRequestMode = mode === "request";

  const loading = isRequestMode ? signRequestUsageLoading : signUsageLoading;

  const error = isRequestMode ? signRequestUsageError : signUsageError;

  const entityDocumentId = getEntityDocumentId(entity);



  const searchToken = useMemo(() => {

    if (isRequestMode) return buildRequestPlaceholder(entity);

    return entityDocumentId;

  }, [isRequestMode, entity, entityDocumentId]);



  const highlightTokens = useMemo(() => {

    if (isRequestMode) {

      return searchTokens.length ? searchTokens : buildRequestSearchTokens(entity);

    }

    return searchTokens.length ? searchTokens : buildSignSearchTokens(entity);

  }, [isRequestMode, entity, searchTokens]);



  const entityTitle = useMemo(() => {

    if (isRequestMode) {

      return entity?.lemma || (entityDocumentId ? entityDocumentId : "—");

    }

    return entity?.lemma || entity?.name || entity?.title || (entityDocumentId ? entityDocumentId : "—");

  }, [isRequestMode, entity, entityDocumentId]);



  const modalTitle = isRequestMode

    ? `Заглушка ${searchToken || ""}`

    : `Жест ${entityDocumentId ?? "?"}`;



  const emptyMessage = isRequestMode

    ? "Заглушка нигде не используется в переводах."

    : "Жест нигде не используется в переводах.";



  useEffect(() => {

    if (!isOpen || !entityDocumentId) {

      setUsageItems([]);

      setTotalTranslations(0);

      setSearchTokens([]);

      return undefined;

    }



    let cancelled = false;



    const load = async () => {

      const result = isRequestMode

        ? await findSignRequestPlaceholderUsage(entity)

        : await findSignUsage(entity);



      if (!cancelled) {

        const items = Array.isArray(result?.items) ? result.items : (Array.isArray(result) ? result : []);

        setUsageItems(items);

        setTotalTranslations(Number(result?.totalTranslations) || 0);

        setSearchTokens(Array.isArray(result?.searchTokens) ? result.searchTokens : []);

      }

    };



    load();



    return () => {

      cancelled = true;

    };

  }, [isOpen, entity, entityDocumentId, isRequestMode, findSignRequestPlaceholderUsage, findSignUsage]);



  return (

    <UniversalModal

      isOpen={isOpen}

      title={modalTitle}

      onClose={onClose}

      footer={(

        <button className="e-btn" type="button" onClick={onClose}>

          Закрыть

        </button>

      )}

    >

      <p className="request-merge-current">

        <strong>{isRequestMode ? "Заявка" : "Жест"}:</strong> {entityTitle}

        {entityDocumentId ? (

          <span className="request-merge-code">documentId: {entityDocumentId}</span>

        ) : null}

      </p>

      <p className="request-merge-hint">

        Поиск по всем переводам в <code className="translation-code">data.signs</code>

        {" "}по токенам:{" "}

        {highlightTokens.map((token, index) => (

          <React.Fragment key={String(token)}>

            {index > 0 ? ", " : null}

            <code className="translation-code">{String(token)}</code>

          </React.Fragment>

        ))}

        {isRequestMode ? (

          <>

            . Заглушки заявок хранятся как <code className="translation-code">p:{"{documentId}"}</code>.

          </>

        ) : (

          <>

            . Жесты хранятся как <code className="translation-code">documentId</code> без префикса.

          </>

        )}

      </p>



      {loading ? (

        <p className="request-merge-hint">

          <i className="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Загрузка переводов…

        </p>

      ) : null}



      {error ? (

        <p className="requests-error">

          <i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i> {error}

        </p>

      ) : null}



      {!loading && !error ? (

        <>

          <p className="request-merge-hint">

            Просмотрено переводов: <strong>{totalTranslations}</strong>

          </p>

          {usageItems.length ? (

          <>

            <p className="request-merge-hint">

              Найдено совпадений: <strong>{usageItems.length}</strong>

            </p>

            <div className="request-usage-table-wrap">

              <table className="request-usage-table">

                <thead>

                  <tr>

                    <th>Предложение</th>

                    <th>Язык перевода</th>

                    <th>Translation</th>

                    <th>data.signs</th>

                  </tr>

                </thead>

                <tbody>

                  {usageItems.map((item) => {

                    const sentenceText = item?.sentence?.text || "—";

                    const sentenceDocumentId = item?.sentence?.documentId;

                    const rowKey = item.translationDocumentId || item.translationId;



                    return (

                      <tr key={rowKey}>

                        <td className="request-usage-sentence">

                          <span>{sentenceText}</span>

                          {sentenceDocumentId ? (

                            <span className="request-usage-meta">sentence {sentenceDocumentId}</span>

                          ) : null}

                        </td>

                        <td>{item.language || "—"}</td>

                        <td>

                          <span className="request-usage-meta">{item.translationDocumentId || `#${item.translationId}`}</span>

                        </td>

                        <td className="request-usage-signs">

                          <code>{formatSignsPreview(item.signs, highlightTokens)}</code>

                        </td>

                      </tr>

                    );

                  })}

                </tbody>

              </table>

            </div>

          </>

        ) : (

          <p className="request-merge-hint">

            <i className="fa-regular fa-folder-open" aria-hidden="true"></i> {emptyMessage}

          </p>

        )}

        </>

      ) : null}

    </UniversalModal>

  );

};



export default SignTranslationUsageModal;

